import { Image, Text } from "@tblabs/truffle";
import { Box } from "../../Components/Utils/Box";
import { BlogArticle } from "../../Models/Blog/BlogArticle";


export class ArticleEditTitle extends Box
{
    constructor(article: BlogArticle)
    {
        super(
            new Image(article.Images.First()?.ThumbnailUrl).Class("category-edit-box-image"),
            new Text(article.Title).Class("category-edit-box-title"),
            new Text(article.PublishDate.value.toLocaleDateString()).MarginLeft(24).Color("#888")
        );
    }
}
